export var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum["DEVELOPMENT"] = "Development";
    EnvironmentEnum["PRODUCTION"] = "Production";
})(EnvironmentEnum || (EnvironmentEnum = {}));
export var EnvironmentTypeEnum;
(function (EnvironmentTypeEnum) {
    EnvironmentTypeEnum["DEV"] = "dev";
    EnvironmentTypeEnum["PROD"] = "prod";
})(EnvironmentTypeEnum || (EnvironmentTypeEnum = {}));
export const PROTECTED_ENVIRONMENTS = [EnvironmentEnum.DEVELOPMENT, EnvironmentEnum.PRODUCTION];
//# sourceMappingURL=environment.js.map